module.exports = __webpack_public_path__ + "img/meimei.4d2cfad5.png";